import { isFunction } from 'utils/helpers';

export const PAGE = 'page';
export const TRACK = 'track';

/**
 * **createEvent**_(type, name, keys, formatter, otherProps)_<br>
 * Creates a new segment event.
 * @param { String } type: The segment event type.
 * @param { String } name: Unique name of the event.
 * @param { Array } keys: Key values of performed action to pass to segment event.
 * @param { Function } formatter: Function to format the event. (e: {}, state: {}) => {}. Passes back the event object and app state.
 * @param { Object } otherProps: Additional props for the event.
 * @returns { Object } The segment event.
 */
const createEvent = (
  type: string,
  name: string,
  keys: Array<any> = [],
  formatter?: (...args: any) => any,
  otherProps: object = {},
): object => ({
  event: type,
  eventName: name,
  eventKeys: keys,
  eventDetailsFormatter: isFunction(formatter) ? formatter : undefined,
  ...otherProps,
});

/**
 * **createTrackEvent**_(name, keys, formatter, otherProps)_<br>
 * Creates a new segment track event.
 * @param { String } name: Unique name of the event.
 * @param { Array } keys: Key values of performed action to pass to segment event.
 * @param { Function } formatter: Function to format the event. (e: {}, state: {}) => {}. Passes back the event object and app state.
 * @param { Object } otherProps: Additional props for the event.
 * @returns { Object } The segment track event.
 */
export const createTrackEvent = (
  name: string,
  keys: string[] = [],
  formatter?: (...args: any) => any,
  otherProps = {},
) => createEvent(TRACK, name, keys, formatter, otherProps);
